module.exports = __webpack_public_path__ + "static/media/photo-6-sm.95aae841.jpeg";